import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const BuildingIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10 6C10 4.34315 11.3431 3 13 3H17C18.6569 3 20 4.34315 20 6V19C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20C3 19.4477 3.44772 19 4 19V13C4 11.3431 5.34315 10 7 10H10V6ZM12 19H18V6C18 5.44772 17.5523 5 17 5H13C12.4477 5 12 5.44772 12 6V19ZM10 19V12H7C6.44772 12 6 12.4477 6 13V19H10ZM13 8C13 7.44772 13.4477 7 14 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H14C13.4477 9 13 8.55228 13 8ZM13 12C13 11.4477 13.4477 11 14 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H14C13.4477 13 13 12.5523 13 12ZM13 16C13 15.4477 13.4477 15 14 15H16C16.5523 15 17 15.4477 17 16C17 16.5523 16.5523 17 16 17H14C13.4477 17 13 16.5523 13 16Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

BuildingIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(BuildingIcon);
